<div class="grid-container">
  <div class="grid-row grid-gap">
    <legend class="usa-legend usa-legend--large">View Freight Bill of Lading</legend>
  </div>
  <div class="grid-row grid-gap">
    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
      <label class="usa-label font-weight-bold">Book Shipment ID: {{bookShipmentId}}</label>
    </div>
  </div>
  <div class="grid-row grid-gap mt-4">
    <ag-grid-angular
      style="width: 100%; height: 200px;"
      class="ag-theme-alpine"
      [gridOptions]="gridOptions"
      [rowData]="selectedNodes"
      [overlayNoRowsTemplate]="overlayNoRowsTemplate"
      [columnDefs]="columnDefs"
      [suppressDragLeaveHidesColumns]="true"
      (gridReady)="onGridReady($event)">
    </ag-grid-angular>
  </div>
  <div class="grid-row grid-gap mt-4">
    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-12 desktop:grid-col-12">
    <button type="button" class="usa-button" (click)="backToShipmentsControl()">Back to Shipments Control</button>
    </div>
  </div>
<!--  <div class="row pt-2">
    <div class="col-md-12">
      <div class="card shadow-sm">
        <div class="card-body p-5">
           <form [formGroup]="viewPdfDocForm">
          <div class="row pb-5">
            <div class="col">
              <h3 class="p-0">View Document Package</h3>
              <div class="row"></div>
              <div class="row">
                  <div class="col-md-2">
                    <div>Book Shipment ID: </div>
                  </div>
                  <div class="col-md-2">
                    <div>{{bookShipmentId}}</div>
                  </div>
                  <div *ngIf="this.isHHGSelected || this.isUABSelected || this.isPOVSelected" class="col-md-2">
                      <div>Last Name: </div>
                  </div>
                  <div *ngIf="this.isHHGSelected || this.isUABSelected || this.isPOVSelected" class="col-md-2">
                      <div>{{employeeLastName}}</div>
                  </div>
              </div>
            </div>
          </div>
          <div *ngIf="message" class="alert alert-success">{{message}}</div>
          <div class="table-responsive">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th colspan="2">Document Type</th>
                  <th colspan="2">View / Print</th>
                  <th colspan="2">Bill Of Lading Number</th>
                </tr>
              </thead>
              &lt;!&ndash;<td><a [routerLink]=""
                      (click)="createEdit('edit', createModal, userDetails)">{{userDetails.email}}</a>
                  </td>&ndash;&gt;
              <tbody>
                 <tr *ngIf="this.isHHGSelected" >
                  <td class="readonly">Bill Of Lading</td>
                  <td>HHG</td>
                  <td><a [routerLink]="[]"
                    (click)="viewDocumentBOLPDF('HHG', 'Original')">Original</a></td>
                  <td><a [routerLink]="[]"
                    (click)="viewDocumentBOLPDF('HHG', 'Memorandom')">Memorandum</a></td>
                  <td class="readonly">{{billOfLadingNbr}}</td>
                  <td class="readonly">Booked</td>
                </tr>
                <tr *ngIf="this.isUABSelected" >
                  <td class="readonly">Bill Of Lading</td>
                  <td class="readonly">HHG-UAB</td>
                  <td><a [routerLink]="[]"
                    (click)="viewDocumentBOLPDF('HHG-UAB', 'Original')">Original</a></td>
                  <td><a [routerLink]="[]"
                    (click)="viewDocumentBOLPDF('HHG-UAB', 'Memorandom')">Memorandum</a></td>
                  &lt;!&ndash;<td class="readonly">P0000001</td>&ndash;&gt;
                  <td class="readonly">{{billOfLadingNbr}}</td>
                  <td class="readonly">Booked</td>
                </tr>
                <tr *ngIf="this.isPOVSelected" >
                  <td class="readonly">Bill Of Lading</td>
                  <td class="readonly">HHG-POV</td>
                  <td><a [routerLink]="[]"
                    (click)="viewDocumentBOLPDF('HHG-POV', 'Original')">Original</a></td>
                  <td><a [routerLink]="[]"
                    (click)="viewDocumentBOLPDF('HHG-POV', 'Memorandom')">Memorandum</a></td>
                  <td class="readonly">{{billOfLadingNbr}}</td>
                  <td class="readonly">Booked</td>
                </tr>
                <tr *ngIf="this.selectedShipmentType === 'FRT'" >
                    <td class="readonly">Bill Of Lading</td>
                    <td class="readonly">FRT</td>
                    <td><a [routerLink]="[]"
                      (click)="viewDocumentBOLPDF('FRT', 'Original')">Original</a></td>
                    <td><a [routerLink]="[]"
                      (click)="viewDocumentBOLPDF('FRT', 'Memorandom')">Memorandum</a></td>
                    <td class="readonly">{{billOfLadingNbr}}</td>
                    <td class="readonly">Booked</td>
                  </tr>
                  <tr *ngIf="isCorrectionNotice && shipmentStatus === 'Booked'" >
                    <td class="readonly">Correction Notice</td>
                    <td class="readonly"></td>
                    <td><a [routerLink]="[]"
                      (click)="viewCorrecionNoticePDF()">Original</a></td>
                    <td></td>
                    <td class="readonly">{{billOfLadingNbr}}</td>
                    <td class="readonly">Booked</td>
                  </tr>
              </tbody>
            </table>
          </div>
          <div class="form-row p-3">
              <div class="bol-final-displayInline pr-2">
                    <button type="button" class="btn btn-primary w-auto" (click)="backToShipmentsControl()">Back to Shipments Control</button>
              </div>
           </div>
          </form>
        </div>
      </div>
    </div>
  </div>-->
</div>
